module.exports = __webpack_public_path__ + "static/media/logo.9c708e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/console/images/logo.png
// module id = 1547
// module chunks = 0